// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"67":"bill","231":"checkout"}[chunkId] + "." + {"67":"e8a03f36","231":"8428b554"}[chunkId] + ".css";
};